import { render } from "./sustainability.section.html?vue&type=template&id=65df1c7a&scoped=true&lang=html&external"
import script from "./sustainability.section.vue?vue&type=script&lang=js"
export * from "./sustainability.section.vue?vue&type=script&lang=js"

import "./_sustainability.section.mobile.scss?vue&type=style&index=0&id=65df1c7a&lang=scss&scoped=true&external"
import "./_sustainability.section.desktop.scss?vue&type=style&index=1&id=65df1c7a&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65df1c7a"]])

export default __exports__